import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleclassroomComponent } from './simple-icons-googleclassroom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleclassroomComponent ],
    exports:      [ SimpleIconsGoogleclassroomComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleclassroomModule {}
